import React, { useState, useEffect, useRef, Fragment } from 'react';
import { useHistory, Link } from 'react-router-dom';

import { IPost } from '../../../helper/Types';

import moment from 'moment';
import InfiniteScroll from "react-infinite-scroll-component";
import { VALazyImage, VALoading } from '../../../components';
import { useQueryParams, StringParam } from 'use-query-params';
import { Link as ScrollLink, Element , Events, animateScroll, scrollSpy, scroller } from 'react-scroll';

type IntrosComponentProps = {
    items: IPost[];
    more: Boolean;
    onLoadMore: (offsetDate:String) => void;
}

function IntrosComponent(props:IntrosComponentProps) {
    const history = useHistory();
    const [more, setMore] = useState(false);
    const [countMedia, setCountMedia] = useState(0);
    const [query, setQuery] = useQueryParams({
        lastIndex: StringParam,
    });

    const handleOnLoad = () => {
        setCountMedia(countMedia + 1);
    }

    useEffect(() => {
        if( countMedia === props.items.length ) {
            const idx:number = parseInt(query.lastIndex as string, 10);
            console.log("[done]scroll : " + idx );
            if( idx >= 0 ) {
                console.log("scroll");
                const target = `uid-${query.lastIndex}`;
                scroller.scrollTo(target, {
                    duration: 500,
                    delay: 0,
                    smooth: true,
                    offset: -72
                });
            }

            setMore(props.more as boolean);
        }

        return() => {
        }
    }, [countMedia]);

    return(
        <>
            <InfiniteScroll
                dataLength={props.items.length}
                next={() => {
                    console.log("InfiniteScroll next");
                    setQuery({
                        lastIndex: "-1"
                    })
                    const _date:String = props.items && props.items[props.items.length-1].date;
                    props.onLoadMore(_date);
                }}
                hasMore={more}
                loader={<VALoading />}
            >
                <ol className="list-intro">
                    {/* { props.items.length === 0 && <li className="none">등록된 내용이 없습니다.</li> } */}
                    { props.items && props.items.map((_post:IPost, _index:number) => {
                        const handleBeforeClick = (e:React.MouseEvent<HTMLSpanElement, MouseEvent>, _index:string, url:string) => {
                            console.log("click : " + _index);
                            setQuery({
                                lastIndex: _index
                            })
                            history.push(url);
                        }

                        return(
                            <li key={_index}>
                                <Element name={`uid-${_index}`} className="intro-item">
                                    <div className="info">
                                        <time dateTime="" className="date">{moment(Number(_post.date)).format("YYYY.MM.DD")}</time>
                                        <strong className="title">{_post.title}</strong>
                                    </div>

                                    <div className="intro-contents">
                                        <div className="media">
                                            <div className="inner">
                                            { _post.cover.length > 0  &&
                                                <button type="button" onClick={(e) => { handleBeforeClick(e, _index.toString(), `/about/introduction/${_post.uid}`); }}><div className="photo"><img src={String(_post.cover[0].url)} alt="" onLoad={handleOnLoad} /></div></button>
                                                // <Link to={`/about/introduction/${_post.uid}`}><div className="photo"><img src={String(_post.cover[0].url)} /></div></Link>
                                            }
                                            </div>
                                        </div>
                                        <p className="description">
                                            {_post.description.split('\n').map( (_item:any, _index:number) => {
                                                return(<Fragment key={_index}>{_item}<br/></Fragment>)
                                            })}
                                        </p>
                                    </div>
                                </Element>
                            </li>
                        );
                    }) }
                </ol>
            </InfiniteScroll>
            {/* <div className="list-actions" data-disabled={!props.more}>
                <button type="button" className="button-read-more" disabled={!props.more} onClick={() => {
                    const _date:String = props.items && props.items[props.items.length-1].date;
                    props.onLoadMore(_date);
                }}>Read More</button>
            </div> */}
        </>
    );
}

export default IntrosComponent;

